import React from "react"
import { Link } from "gatsby"

import { withNavigationAccount } from "./withNavigationAccount"

export const NavigationAccount = withNavigationAccount(
  ({ items }): JSX.Element => (
    <>
      {items?.length > 0 && (
        <nav>
          <ul>
            {items?.map(({ title, url }, index) => (
              <li key={index}>
                <Link to={url}>{title}</Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </>
  )
)
